var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSheduledNoti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.7799 9.33333V4M21.4466 9.33333V4M9.44661 14.6667H22.7799M6.77995 28H25.4466C26.9194 28 28.1133 26.8061 28.1133 25.3333V9.33333C28.1133 7.86057 26.9194 6.66667 25.4466 6.66667H6.77995C5.30719 6.66667 4.11328 7.86057 4.11328 9.33333V25.3333C4.11328 26.8061 5.30719 28 6.77995 28Z",
    stroke: "#111418",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheduledNoti);
export default __webpack_public_path__ + "static/media/sheduled-noti.6b047b73c1c573be88161fb6cdca2963.svg";
export { ForwardRef as ReactComponent };